import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import videoImg from "@baseImg/videos/video-aboutus-02.webp";
import VideoModal from "@components/base/Modal/VideoModal/VideoModal";

const BG = {
	blockIntro: {
		top: {
			blockTitle: 'Екип',
			blockDesc: 'Екипът прави superhosting! Повече от 20 години обслужваме стотици клиенти всеки ден с желание и емпатия. Днес над 100 професионалисти работят за по-доброто клиентско изживяване.',
			titleSize: 'h3',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		},
		bottom: {
			blockTitle: '',
			blockDesc: `
					<p>
						За да опознаеш отблизо екипа ни, създадохме проекта <a href="https://blog.superhosting.bg/category/meetthesupers" target="_blank" rel="nofollow">#MeetTheSupers</a>.
						В него колегите споделят своите силни страни, ежедневието си в superhosting и личната си „рецепта за успех“.
					</p>
					<p>
						Искаш да станеш част от екипа на superhosting?
					</p>
			  `,
			titleSize: 'h3',
			buttonText: 'Виж свободни позиции',
			buttonAction: 'RedirectTo',
			buttonParams: [
				'https://superhosting.teamtailor.com',
				'_blank'
			],
			ButtonModal: '',
			buttonModalParams: {}
		}
	},
	blockContent:
	  {
		  title: 'Екип',
		  img: videoImg,
		  platform: 'wistia',
		  videoId: 'q72ki42zuw',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2025-12-11T10:34:00+00:00",
		  watchText: 'Гледай в YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockIntro: {
		top: {
			blockTitle: 'Our team',
			blockDesc: 'The team is what makes Superhosting. For more than 20 years, we have been serving hundreds of clients every day with dedication and empathy. Today, over 100 professionals work together to deliver an outstanding customer experience.',
			titleSize: 'h3',
			buttonText: '',
			buttonAction: '',
			buttonParams: [],
			ButtonModal: '',
			buttonModalParams: {}
		},
		bottom: {
			blockTitle: '',
			blockDesc: `
					<p>
						To help you get to know our team better, we created the <a href="https://blog.superhosting.bg/category/meetthesupers" target="_blank" rel="nofollow">#MeetTheSupers</a> project, where our colleagues share their strengths, their daily work at SuperHosting, and their personal “recipe for success.”
					</p>
					<p>
						Want to become part of the SuperHosting team?
					</p>
			  `,
			titleSize: 'h3',
			buttonText: 'Explore our open positions',
			buttonAction: 'RedirectTo',
			buttonParams: [
				'https://superhosting.teamtailor.com',
				'_blank'
			],
			ButtonModal: '',
			buttonModalParams: {}
		}
	},
	blockContent:
	  {
		  title: 'Our Team',
		  img: videoImg,
		  platform: 'wistia',
		  videoId: '2x62suhy3y',
		  VideoModal: VideoModal,
		  modalParams: {
			  data: '#data#',
			  color: '#color#',
			  platform: '#platform#',
			  key: '#key#'
		  },
		  autoPlay: true,
		  uploadDate: "2025-12-11T10:34:00+00:00",
		  watchText: 'Watch on YouTube'
	  }
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];